(() => {
  const dimensionExpression = /\b\d+(?:[.,]\d+)?(?:\s*\([a-z]{1,3}\))?(?:\s*[x×]\s*\d+(?:[.,]\d+)?(?:\s*\([a-z]{1,3}\))?){1,3}(?:\s*(?:mm|cm|inches|inch|in|m)\b)?/gi;
  const excludedElements = 'script, style, noscript, textarea, input, select, option, button, pre, code, svg';

  function formatTextNode(node) {
    const parent = node.parentElement;
    if (!parent || parent.closest(excludedElements)) return;

    const original = node.nodeValue;
    const formatted = original.replace(dimensionExpression, (expression) =>
      expression
        .replace(/(\d)\s*\(/g, '$1 (')
        .replace(/\s*[x×]\s*/gi, ' × ')
    );

    if (formatted !== original) node.nodeValue = formatted;
  }

  function formatSubtree(root) {
    if (root.nodeType === Node.TEXT_NODE) {
      formatTextNode(root);
      return;
    }

    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;
    if (root.nodeType === Node.ELEMENT_NODE && root.matches(excludedElements)) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let textNode;
    while ((textNode = walker.nextNode())) formatTextNode(textNode);
  }

  function initialize() {
    const content = document.querySelector('#MainContent');
    if (!content) return;

    formatSubtree(content);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach(formatSubtree);
      });
    });

    observer.observe(content, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
